// extracted by mini-css-extract-plugin
export default {"root":"OwnOperationsView_root__h9hjz","panel":"OwnOperationsView_panel__Ki82L","content":"OwnOperationsView_content__C8lIj"};